/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Create/view.blocks to change it.
import CancelAction from './CancelAction/index'
import CreateAction from './CreateAction/index'
import Expires from './Expires/index'
import ExpiresAt from './ExpiresAt/index'
import React from 'react'
import TermsAndConditionsAgreement from './TermsAndConditionsAgreement/index'
import Title from './Title/index'
import TysiaModalContent from 'DesignSystem/TysiaModal/TysiaModalContent/index'
import TysiaModalFooter from 'DesignSystem/TysiaModal/TysiaModalFooter/index'



/** @type {import('Simple/types.js').View} */
export default function Create({
  children,
  viewPath = "/App/Account/Content/Settings/Content/ConnectDevelopers/CreateToken/Content/Create"
  
}) {
  return (<React.Fragment
>
<TysiaModalContent
  viewPath={`${viewPath}/TysiaModalContent`}
>
{childProps => (
<React.Fragment>
<Title
{...childProps}
  viewPath={`${viewPath}/Title`}
/>
<Expires
{...childProps}
  viewPath={`${viewPath}/Expires`}
/>
<ExpiresAt
{...childProps}
  viewPath={`${viewPath}/ExpiresAt`}
/>
<TermsAndConditionsAgreement
{...childProps}
  viewPath={`${viewPath}/TermsAndConditionsAgreement`}
/>
</React.Fragment>
)}
</TysiaModalContent>
<TysiaModalFooter
  viewPath={`${viewPath}/TysiaModalFooter`}
>
{childProps => (
<React.Fragment>
<CancelAction
{...childProps}
  viewPath={`${viewPath}/CancelAction`}
/>
<CreateAction
{...childProps}
  viewPath={`${viewPath}/CreateAction`}
/>
</React.Fragment>
)}
</TysiaModalFooter>
{children}
</React.Fragment>)
}